import { EventEmitter, Output, Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { GlobalDataService } from '../../housekeeping/services/global-data.service';
import { FileUploadService } from '../../housekeeping/services/file-upload.service';
import { GlobalVariable } from '../../../../app/config';
import {HttpClient, HttpRequest, HttpEvent} from '@angular/common/http';

@Injectable()
export class LeadService {
    public BASE_URL = GlobalVariable.FORDAPIEndPointURL;

    @Output() leadno: EventEmitter<boolean> = new EventEmitter(true);
    constructor(public _router: Router,public _globalDataService:GlobalDataService,public _fileUploadService:FileUploadService,private http: HttpClient) {}

    /**
    * @author Ciocan Vlad
    * @uses get the vehicle purpose list
    */
    getVehiclePurposeList(userId,callback){
      this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/vehiclePurpose/list", (result) => {
            callback(result);
        })
    }


    /**
    * @author Ciocan Vlad
    * @uses view the leads detail page
    */
    viewLeadsDetails(leadId,userId,callback) {
         this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/lead/details?userId="+userId+"&leadId="+leadId, (result) => {
            callback(result);
        })
    }
    /**
    * @author Ciocan Vlad
    * @uses set the lead id
    */
    setLeadNo(leadId) {
        this.leadno.emit(leadId);
    }
    /**
    * @author Ciocan Vlad
    * @uses get the lead id
    */
    getLeadNo() {
        return this.leadno;
    }

      /**
     * @author Pradeep
     * @param
     * @returns country names
     */
    getCountryList(userid,callback){
        this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/country/list", (result) => {
            callback(result);
        })
    }
     /**
     * @author Pradeep
     * @param
     * @returns priority names
     */
    getPriorityList(userid,callback){
        this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/priority/list", (result) => {
            callback(result);
        })
    }
      /**
     * @author Pradeep
     * @param
     * @returns lead source names
     */
    getLeadSourceList(userid,callback){
        this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/lead/source/list", (result) => {
            callback(result);
        })
    }
           /**
     * @author Pradeep
     * @param
     * @returns status names
     */
    getStatusList(userid,callback){
        this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/lead/status/list", (result) => {
            callback(result);
        })

    }

     /**
     * @author Nagendra
     * @param userid,offset,limit
     * @returns List of lead assigned to user
     */
    getLeadList(userid,offset,limit,column,sort,callback) {
//        console.log(this.BASE_URL + "/lms/lead/list?userId="+ userid+"&offset="+offset+"&pageLimit="+limit+"&orderBy="+column+"&sortBy="+sort);
        this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/lead/list?userId="+ userid+"&offset="+offset+"&pageLimit="+limit+"&orderBy="+column+"&sortBy="+sort, (result) => {
        callback(result);
        })
    }

    /**
     * @author Parvathi
     * @description Get websites and campaign names
     */

     getWebsiteAndCampaignName(callback){
         this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/lead/websiteAndCampaignName/list", (result) => {
            callback(result);
        })
     }

    /**
     * @author Nagendra
     * @param userid,searchText,offset,limit,callback
     * @returns Search List
     */
    getLeadSearch(userid,searchText,offset,limit,column,sort,callback){
//        console.log(this.BASE_URL + "/lms/lead/search?userId="+userid+"&searchKey="+searchText+"&offset="+offset+"&pageLimit="+limit+"&orderBy="+column+"&sortBy="+sort);
        this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/lead/search?userId="+userid+"&searchKey="+searchText+"&offset="+offset+"&pageLimit="+limit+"&orderBy="+column+"&sortBy="+sort, (result) => {
        callback(result);
        })
    }
   /**
     * @author Ciocan Vlad
     * @param
     * @returns get all vehicle make list
     */
     getMakeList(userId,callback){
       this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/brand/make/list", (result) => {
            callback(result);
        })
    }

     /**
     * @author Ciocan Vlad
     * @param
     * @returns get all vehicle model list
     */
     getModelList(make,callback){
       this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/brand/model/list?make="+make, (result) => {

            callback(result);
        })
    }
     /**
     * @author Ciocan Vlad
     * @param
     * @returns get all current vehicle model list
     */

    getCurrentVehicleList(vehiclename,callback){

          this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/otherBrand/list?searchKey="+vehiclename, (result) => {

            callback(result);
        })
    }
     /**
     * @author Ciocan Vlad
     * @param
     * @returns get all current vehicle model list
     */
     getDealerList(userId,callback){

          this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/dealer/list?userId="+userId, (result) => {
            callback(result);
        })
    }
    /**
     * @author Ciocan Vlad
     * @param
     * @returns get all assigned to list
     */
     getAssignedToList(dealerId,callback){

          this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/assignedUser/list?dealerId="+dealerId, (result) => {
            callback(result);
        })
    }

     /**
     * @author Ciocan Vlad
     * @param
     * @returns get all call to action list
     */
     getcallToActionList(userId,callback){
          this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/callToAction/list", (result) => {

            callback(result);
        })
    }
        /**
     * @author Ciocan Vlad
     * @param
     * @returns get time frame list
     */
     gettimeFrameList(userId,callback){
          this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/purchaseIntention/list", (result) => {
            callback(result);
        });
    }
     /**
     * @author Ciocan Vlad
     * @param lead form data
     * @returns save lead data
     */
    saveLead(leadsform,callback){
        this._globalDataService.PostAjaxCall(this.BASE_URL + "/lms/lead/save",leadsform ,(result) => {
            callback(result);
        });

       this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/lead/changeLog/get?leadId="+leadsform.id, (refreshResult) => {});
     }
     closeLead(leadsform, callback){
          this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/lead/close?leadId="+leadsform.id ,(result) => {
              callback(result);
          })
     }


    saveleadActivities(leadActivity,callback){
        this._globalDataService.PostAjaxCall(this.BASE_URL + "/lms/lead/activity/save",leadActivity ,(result) => {

            callback(result);
        })
    }
    deleteleadActivities(leadActivityid,callback){
        this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/lead/activityDelete?activityId="+leadActivityid,(result) => {

            callback(result);
        })
    }


    /**
     * @author Nagendra
     * @description Get User preferences
     */
    getUserPreference(userId,callback){
//        console.log(this.BASE_URL + "/lms/lead/userPreference/get?userId="+userId);
        this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/lead/userPreference/get?userId="+userId, (result) => {
            callback(result);
        })
    }

    /**
     * @author Nagendra
     * @description Save User preferences
     */
    saveUserPreference(savePreference,callback){
        this._globalDataService.PostAjaxCall(this.BASE_URL + "/lms/lead/userPreference/save",savePreference, (result) => {
        callback(result);
        })
    }
      /**
     * @author Pradeep
     * @description get log Details for lead
     */

     getLeadLogDetails(leadId,callback){
         this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/lead/changeLog/get?leadId="+leadId, (result) => {
            callback(result);
        })
     }

     /**
     * @author Nagendra
     * @description Get All User preferences
     */

     getviewSettings(callback){
//         console.log(this.BASE_URL + "/lms/lead/viewSettings/list");
         this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/lead/viewSettings/list", (result) => {
            callback(result);
        })
     }

     /**
      * @author Nagendra
      * @description To Lead Default Preferences.
      */
    setDefaultPreferenceForLead(current,remaining) {
        current = [];
        remaining = [];
        this.getviewSettings(allPreference => {
            allPreference.forEach(Obj => {
                if (Obj.isDefult == true) {current.push(Obj.label)}
                if (Obj.isDefult == false) {remaining.push(Obj.label)}
            });

        });
        return [current,remaining];
    }

    /**
     * @author Anand
     * @description Check event id already exist or not.
     */
    checkEventId(event,callback){
      const objId = (event.id == undefined) ? 0 : event.id;
      this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/lead/validationEvent?eventName="+event.eventId+"&id="+objId, (result) => {
            callback(result);
        },false);
    }

     /**
     * @author Pradeep
     * @description Save bulkupload data
     */

    bulkFileUploadData(userId, filedata, callback) {
        this._fileUploadService.makeFileRequest(this.BASE_URL + "/lms/lead/upload?userId=" + userId, [], filedata).then((result: Array<any>) => {
            //console.log("************1******"+JSON.stringify(result))
            callback(result)
        }, (error) => {
            console.log("***********2*******" + JSON.stringify(error))
        });
    }
    /*
     * @author Nagendra
     * @uses To get event id values
     * @date 22-10-2018
     * @modified date 22-10-2018
     */
    getEventValues(callback){
        this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/lead/event/list", (result) => {
            callback(result);
        })
    }

    /*
     * @author Nagendra
     * @uses To get event id values
     * @date 22-10-2018
     * @modified date 22-10-2018
     */
    getVOIValues(callback){
        this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/brand/list", (result) => {
            callback(result);
        })
    }


     /*
     * @author Nagendra
     * @uses To get country id values
     * @date 25-10-2018
     * @modified date 25-10-2018
     */
     getCountrytWithNameCode(userid,callback){
        this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/country/list", (result) => {
          const temp = [];
          result.forEach(obj => {
                temp.push({
                    id:obj.id,
                    name:obj.name,
                    code:obj.code,
                    namecode : obj.name+"("+obj.code+")"
                })
            });
        callback(temp);
        })
    }

    /*
     * @author Nagendra
     * @uses To get event id values
     * @date 22-10-2018
     * @modified date 25-10-2018
     */
    getEventWithDescription(callback){
      const temp = [];
      this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/lead/event/list", (result) => {
            result.forEach(obj => {
                temp.push({
                    id: obj.id,
                    eventId: obj.eventId,
                    eventDescription: obj.eventDescription,
                    idWithDescription: obj.eventId + '(' + obj.eventDescription + ')'
                })
            });
        callback(temp);
        })
    }

     /*
     * @author Nagendra
     * @uses To get event id values
     * @date 25-10-2018
     * @modified date 25-10-2018
     */
    getVOIMakeModel(callback){
      const temp = [];
      this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/brand/list", (result) => {
                result.forEach(obj => {
                temp.push({
                    id: obj.id,
                    make: obj.make,
                    model: obj.model,
                    makeModel: obj.model + '(' + obj.make + ')'
                })
            });

            callback(temp);
        })
    }
  /*
     * @author Vanitha
     * @uses update page limit
     * @date 20-11-2019
     */
       updatePageLimit(userId, limit,callback){
       this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/user/updatePageLimit?userId=" + userId + "&pageLimit=" + limit, result => {
            callback(result);

        })
       }
        /*
     * @author Vanitha
     * @uses region list
     * @date 20-11-2019
     */

        getRegionList(callback){
         this._globalDataService.GetAjaxCall(this.BASE_URL + '/lms/user/region/list', (result) => {
            callback(result);

        });
    }
    }





// WEBPACK FOOTER //
// ./src/app/modules/leads/services/lead.service.ts